import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IHistory } from "../se-timeline.models";
import { Store } from "@ngrx/store";
import { seTimelineComponentSetSelectedItem } from "../redux/se-timeline.actions";
import { SearchFormType } from "../../search-page/search-page-type.enum";

@Component({
    selector: 'se-timeline-details',
    templateUrl: './se-timeline-details.component.html',
    styleUrl: './se-timeline-details.component.scss'
})

export class SeTimelineDetailsComponent implements OnInit, OnChanges {

    @Input() clinicalHistory : IHistory[] = [];
    @Input() formType : SearchFormType;
    @HostListener('window:resize', ['$event'])
    onResize (event: ResizeObserver) {
        this.visitsAndPositions = this._calculateIconPositions(this.clinicalHistory);
    }
    yearAndWidth : any[] = [];
    visitsAndPositions : any = [];
    objectKeys = Object.keys;

    //////////////////// TESTING ALGORITHM /////////////////////////////////
    constructor (private store: Store) {
    }

    ngOnChanges (changes : SimpleChanges) : void {
        this.visitsAndPositions = this._calculateIconPositions(this.clinicalHistory);
    }

    ngOnInit () : void {
        //this.screenWidth = window.innerWidth;
        //this.sectionWidth = this.screenWidth / this.monthsInYear;
        console.log('onInit Timeline details');
    }

    _onItemSelection (visit : any) {
        //TODO_DGS modificare selectedItem con i dati necessari alla selezione in storia clinica
        this.store.dispatch(seTimelineComponentSetSelectedItem({ formType: this.formType, selectedItem: visit.description }));
    }

    private calculateYearWidths (data : IHistory[]) : any[] {
        const screenWidth : number = window.innerWidth; // Width of the screen
        const baseVisitWidth : number = 25; // Width in pixels for each visit
        const totalVisitWidth : number = data.reduce((acc, yearData) => acc + yearData.visits.length * baseVisitWidth, 0); // Total width required for all visits

        const yearWidths : any = {};
        data.forEach(yearData => {
            const yearVisitsWidth : number = yearData.visits.length * baseVisitWidth;
            const yearWidth : number = (yearVisitsWidth / totalVisitWidth) * screenWidth;
            yearWidths[yearData.year] = yearWidth;
        });

        return yearWidths;
    }

    _calculateIconPositions (data : IHistory[]) : { [year : string] : { description : string, position : number, date : Date; }[]; } {
        return data.reduce((result, { year, visits }) => {
            const iconWidth : number = 25; // Width in pixels for each icon
            const yearWidth : number = this.retrieveWidth(year); // Retrieve width for the year
            // const totalMonths : number = 12; // Total number of months in a year
            // const monthsPerIcon : number = totalMonths / visits.length; // Number of months per icon
            const maxIcons = Math.floor(yearWidth / iconWidth); // Maximum number of icons that can fit in the year
            const visitsCount : number = visits.length;
            const averageWidthPerVisit : number = yearWidth / visitsCount; // Average width available for each visit

            const visitPositions : { description : string, position : number; date : Date; }[] = [];
            visits.slice(0, maxIcons).forEach(({ date, description }, index) => {
                // Calculate the position based on the month of the visit
                const month = date.getMonth() + 1; // Month index starts from 0, so add 1
                //const position = (month - 1 + index * monthsPerIcon) * (yearWidth / totalMonths) +  averageWidthPerVisit / 2 - iconWidth / 2; // Center the icon within the month
                const position = (index * averageWidthPerVisit) + (averageWidthPerVisit / 2) - (iconWidth / 2);
                visitPositions.push({ description, position, date });
            });

            result[year] = visitPositions;
            return result;
        }, {});
    }

    retrieveWidth (year : string) : number {
        this.yearAndWidth = this.calculateYearWidths(this.clinicalHistory);
        return this.yearAndWidth[Number(year)]; // ritorna la lunghezza che può prendere il div dell'anno.
    }


    /////////////////// TODO_DGS - TEST 2 - with recursive grouping --> to fix //////////////////////////

    //elementWidth = 25;
    //elementHeight = 25;
    //screenWidth = 0;
    //monthsInYear = 12;
    //sectionWidth = 0;
    //newElements : TimelineElement[] = [];

    //groupElements (elements : TimelineElement[], maxElements : number) : TimelineElement[] {
    //    if (elements.length <= maxElements) {
    //        return elements;
    //    }

    //    const groupedContent = elements.map(e => e.content).join(", ");
    //    return [{
    //        date: elements[0].date,
    //        content: `Group: ${groupedContent}`,
    //        grouped: true,
    //    }];
    //}

    //positionElements (elements : TimelineElement[]) : TimelineElement[] {
    //    // Sort elements by date
    //    elements.sort((a, b) => a.date.getTime() - b.date.getTime());

    //    const positionedElements : TimelineElement[] = [];
    //    const maxElementsPerSection = Math.floor(this.sectionWidth / this.elementWidth);

    //    let currentYear = elements.length > 0 ? elements[0].date.getFullYear() : null;
    //    let yearIndex = 0;

    //    while (elements.length > 0) {
    //        const currentYearElements = elements.filter(e => e.date.getFullYear() === currentYear);
    //        elements = elements.filter(e => e.date.getFullYear() !== currentYear);

    //        for (let monthIndex = 0; monthIndex < this.monthsInYear; monthIndex++) {
    //            const monthElements = currentYearElements.filter(e => e.date.getMonth() === monthIndex);
    //            const positionedMonthElements = this.groupElements(monthElements, maxElementsPerSection);

    //            positionedMonthElements.forEach((element, index) => {
    //                element.position = {
    //                    top: (yearIndex * this.monthsInYear + monthIndex) * this.elementHeight,
    //                    left: monthIndex * this.sectionWidth + (element.grouped ? 0 : index * this.elementWidth),
    //                };
    //                positionedElements.push(element);
    //            });
    //        }

    //        currentYear = elements.length > 0 ? elements[0].date.getFullYear() : null;
    //        yearIndex++;
    //    }

    //    // Check if the last year's elements are grouped and attempt to ungroup if possible
    //    const lastYear = yearIndex - 1;
    //    const lastYearElements = positionedElements.filter(e => e.position && Math.floor(e.position.top / this.elementHeight) >= lastYear * this.monthsInYear);
    //    const ungroupedLastYearElements = lastYearElements.filter(e => !e.grouped);

    //    if (ungroupedLastYearElements.length === lastYearElements.length) {
    //        return positionedElements;
    //    }

    //    // Attempt to ungroup the last year elements if they fit within the screen width
    //    const lastYearUngrouped = elements.filter(e => e.date.getFullYear() === lastYear + elements[0].date.getFullYear());

    //    if (lastYearUngrouped.length <= maxElementsPerSection) {
    //        const newLastYearElements = this.groupElements(lastYearUngrouped, maxElementsPerSection);
    //        positionedElements.splice(positionedElements.length - lastYearElements.length, lastYearElements.length, ...newLastYearElements);
    //    }

    //    return positionedElements;
    //}


}
